
import { PackageProps } from "../../store/actionType";
import HandleDeletePackage from "./components/HandleDeletePackage";
type CreateUserProps = {
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
  packageData: PackageProps;
};
const DeletePackage: React.FC<CreateUserProps> = ({ closeModal, packageData }) => {
  return (
    <>
      <HandleDeletePackage packageData={packageData} closeModal={closeModal} />
    </>
  );
};
export default DeletePackage;
